<template>
  <div>
    <v-layout justify-center>
      <v-flex
        xs12
        sm12
        md10
        lg5
        xl5
      >
        <v-card
          flat
          class="my-3"
          style="border-radius: 8px; border: 1px solid #ddd"
        >
          <v-card-title>
            <v-flex xs12>
              <router-link
                class="mr-2"
                to="/my-export-order"
              >
                <i class="fa fa-chevron-left"></i>
                Back
              </router-link>
              <span style="font-size: 20px; font-weight: bold">Export Order Detail</span>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <table class="detail-table">
              <tbody>
                <tr>
                  <td class="section-title">Order Info</td>
                </tr>
                <tr>
                  <td><b>Order Number</b></td>
                  <td>{{ instance.order_number }}</td>
                </tr>
                <tr>
                  <td><b>Customer Name</b></td>
                  <td>{{ instance.customer.full_name }}</td>
                </tr>
                <tr>
                  <td><b>Customer Phone</b></td>
                  <td>{{ instance.customer.phone_number }}</td>
                </tr>
                <tr>
                  <td><b>Product Name</b></td>
                  <td>{{ instance.product_name }}</td>
                </tr>
                <tr>
                  <td><b>Quantity</b></td>
                  <td>{{ instance.quantity }}</td>
                </tr>
                <tr v-if="instance.weight">
                  <td><b>Weight</b></td>
                  <td>{{ instance.weight }} {{ instance.weight ? instance.weight_unit : '' }}</td>
                </tr>
                <tr v-if="instance.volume_l">
                  <td><b>Volume (L)</b></td>
                  <td>{{ instance.volume_l }}</td>
                </tr>
                <tr v-if="instance.volume_w">
                  <td><b>Volume (W)</b></td>
                  <td>{{ instance.volume_w }}</td>
                </tr>
                <tr v-if="instance.volume_h">
                  <td><b>Volume (H)</b></td>
                  <td>{{ instance.volume_h }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Price Info</td>
                </tr>
                <tr>
                  <td><b>Shipping</b></td>
                  <td>{{ instance.shipping | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>International Tax</b></td>
                  <td>{{ instance.national_tax | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Delivery</b></td>
                  <td>{{ instance.delivery_price | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Discount</b></td>
                  <td>{{ instance.discount | usdFormat }}</td>
                </tr>
                <tr>
                  <td><b>Price</b></td>
                  <td>{{ instance.price | usdFormat }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Status Info</td>
                </tr>
                <tr>
                  <td><b>Status</b></td>
                  <td>
                    <span
                      style="border-radius: 6px; text-transform: capitalize; font-size: 11px"
                      class="label px-2"
                      :class="{
                      'bg-orange-600': instance.status === 1,
                      'bg-indigo-600': instance.status === 2,
                      'bg-danger-600': instance.status === 3,
                      'bg-green-600': instance.status === 4,
                      'bg-primary-600': instance.status === 5,
                      'bg-teal-600': instance.status === 6,
                      'bg-purple-600': instance.status === 7
                    }"
                    >
                      {{ instance.status_text }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b>Ordered At</b></td>
                  <td>{{ instance.created_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_at">
                  <td><b>Canceled At</b></td>
                  <td>{{ instance.canceled_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.canceled_by">
                  <td><b>Canceled By</b></td>
                  <td>{{ instance.canceled_by ? instance.canceled_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.approved_at && instance.status !== 7">
                  <td><b>Approved At</b></td>
                  <td>{{ instance.approved_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.approved_by && instance.status !== 7">
                  <td><b>Approved By</b></td>
                  <td>{{ instance.approved_by ? instance.approved_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.status === 7 && instance.last_refund_date">
                  <td><b>Refunded At</b></td>
                  <td>{{ instance.last_refund_date | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.status === 7 && instance.refunds && instance.refunds.length > 0">
                  <td><b>Refunded By</b></td>
                  <td>{{ instance.refunds[0].created_by ? instance.refunds[0].created_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.is_fully_refunded">
                  <td><b>Refund Status</b></td>
                  <td>
                    <span class="label bg-purple-600" style="border-radius: 6px; font-size: 11px">
                      Fully Refunded
                    </span>
                  </td>
                </tr>
                <tr v-if="instance.sent_at">
                  <td><b>Sent At</b></td>
                  <td>{{ instance.sent_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.sent_by">
                  <td><b>Sent By</b></td>
                  <td>{{ instance.sent_by ? instance.sent_by.full_name : '' }}</td>
                </tr>
                <tr v-if="instance.received_at">
                  <td><b>Received At</b></td>
                  <td>{{ instance.received_at | moment("YYYY-MM-DD hh:mm a") }}</td>
                </tr>
                <tr v-if="instance.received_by">
                  <td><b>Received By</b></td>
                  <td>{{ instance.received_by ? instance.received_by.full_name : '' }}</td>
                </tr>
                <tr>
                  <td colspan="2">&nbsp;</td>
                </tr>
                <tr>
                  <td class="section-title">Receiver Info</td>
                </tr>
                <tr>
                  <td><b>Name</b></td>
                  <td>{{ instance.receiver_name }}</td>
                </tr>
                <tr>
                  <td><b>Phone</b></td>
                  <td>{{ instance.receiver_phone }}</td>
                </tr>
                <tr>
                  <td><b>Email</b></td>
                  <td>{{ instance.receiver_email }}</td>
                </tr>
                <tr>
                  <td><b>Country</b></td>
                  <td>{{ instance.to_country ? instance.to_country.country_name : '' }}</td>
                </tr>
                <tr>
                  <td><b>City</b></td>
                  <td>{{ instance.receiver_city }}</td>
                </tr>
                <tr>
                  <td><b>Address</b></td>
                  <td>{{ instance.receiver_address }}</td>
                </tr>
                <tr>
                  <td><b>ZIP Code</b></td>
                  <td>{{ instance.receiver_zip_code }}</td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  data() {
    return {
      instance: {
        customer: {},
        to_country: {},
        canceled_by: {},
        approved_by: {},
        sent_by: {},
        received_by: {}
      }
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      let token = localStorage.getItem('access_token')

      Axios
        .get(`api/export-order/${this.$route.params.id}`, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.instance = response.data.data
        })
    }
  }
}
</script>

<style scoped>
.detail-table .section-title {
  padding-left: 0px;
  padding-top: 0px;
  opacity: 0.7;
}

.detail-table tr td {
  padding: 3px 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/exportOrder/myExportOrderDetail.vue